import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import MobileHeader from './MobileHeader';
import MobileNavigation from './MobileNavigation';
import DashboardHome from '../dashboard/DashboardHome';
import ContentIdeas from '../dashboard/ContentIdeas';
import Analytics from '../dashboard/Analytics';
import Settings from '../dashboard/Settings';
import Help from '../dashboard/Help';
import DashboardPricing from '../dashboard/DashboardPricing';
import SavedPlans from '../dashboard/SavedPlans';
import Calendar from '../dashboard/calendar/Calendar';
import LoadingScreen from '../LoadingScreen';

interface User {
  name: string;
  isNewUser: boolean;
}

export default function MobileDashboard() {
  const user: User = {
    name: 'João Silva',
    isNewUser: true
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <MobileHeader />
      
      <main className="pt-16 pb-20">
        <div className="px-4 py-6">
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/" element={<DashboardHome user={user} />} />
              <Route path="/ideias" element={<ContentIdeas user={user} />} />
              <Route path="/calendario" element={<Calendar />} />
              <Route path="/analises" element={<Analytics />} />
              <Route path="/precos" element={<DashboardPricing />} />
              <Route path="/planos" element={<SavedPlans />} />
              <Route path="/configuracoes" element={<Settings user={user} />} />
              <Route path="/ajuda" element={<Help />} />
            </Routes>
          </Suspense>
        </div>
      </main>

      <MobileNavigation />
    </div>
  );
}